import { ControlData, SelectOptions } from '../../ApisForm.model';

export type PersonalDataProps = {
	/**
	 * Control errors
	 * @type ErrorFormPersonalData
	 */
	errorForm?: ErrorFormPersonalData;
	/**
	 * Type passenger
	 * @type TypePassenger
	 */
	typePassenger: TypePassengerAdultChild | TypePassengerInfant;
};

export type ModelPersonalData = {
	name: ControlData;
	surname: ControlData;
	birthDate: ControlData;
	nationality: ControlData;
	country?: ControlData;
	gender: ControlData;
};

export type FormPersonalData = {
	name: string;
	surname: string;
	birthDate: string;
	nationality: SelectOptions;
	country?: SelectOptions;
	gender: string;
};
export type ErrorFormPersonalData = {
	name?: string;
	surname?: string;
	birthDate?: string;
	nationality?: string;
	country?: string;
	gender?: string;
};

export type Gender = 'Male' | 'Female' | undefined;
export type TypePassengerAdultChild = 'ADULT' | 'CHILD';
export type TypePassengerInfant = 'INFANT';
export type TypePassenger = TypePassengerAdultChild | TypePassengerInfant;

export type GenderOption = {
	value: 'MALE' | 'FEMALE';
	label: 'GENDER_MALE' | 'GENDER_FEMALE';
};

export const errorForm: ErrorFormPersonalData = {
	name: undefined,
	surname: undefined,
	birthDate: undefined,
	nationality: undefined,
	country: undefined,
	gender: undefined
};

export const REGEXP_NAME_SURNAME =
	/^[a-zA-Z \-.'àÀáÁâÂãÃäÄåÅæÆçÇèÈéÉêÊëËìÌíÍîÎïÏðÐñÑòÒóÓôÔöÖøØùÙúÚûÛüÜýÝþÞÿŸßčČćĆšŠžŽđĐŁłÕõŻżŚśŔŕĚěŘřŃńŇňŹź]+$/;
